<template>
  <div class="wrap">
    <grid-wmx :item="object" type="yb"></grid-wmx>
  </div>
</template>

<script>
import gridWmx from '@/views/common//grid-wmx'
import { getAction, postAction } from '@/api/manage'
export default {
  components: {
    gridWmx,
  },
  data() {
    return {
      object: {},
      id:'',
    }
  },
  created() {
    let e = this.$route.query
    this.id = e.id
    this.getData()
  },
  methods: {
    getData() {
      let params = {
        pageNo: '1',
        id: this.id,
      }
      getAction('/zhshj/sbdwmx/page/qzsb', params).then((res) => {
        if (res.success) {
          let obj = res.result
          this.object = obj.records[0]
        }
      })
    },
   
  },
}
</script>

<style lang="less" scoped>
.wrap {
  min-height: 100vh;
  background: #f5f5f5;
}
.heard {
  position: fixed;
  top: 0px;
  left: 0px;
  width: 100%;
  z-index: 1;
}

.b-btn {
  padding: 0 20px;
  margin: 20px 0;

  .b-button {
    width: 100%;
    height: 44px;
    background: #3f8ffb;
    border-radius: 5px;
    opacity: 1;
    border: none;
    color: #ffffff;
  }

  .b-button[disabled] {
    opacity: 0.48;
  }
}

.xxnr {
  width: 90%;
  margin: 0 12px;
  height: 128px;
  border-radius: 5px;
  border: 1px solid #ededed;
  padding: 8px;
  font-size: 14px;
}

.content {
  background: #fff;
}
</style>
